'use client';

import type { ReactNode } from 'react';
import { Badge } from '@terra/ui-design-system';

export function ListPageTablePill({
  children,
  icon,
}: {
  children: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <Badge
      variant="outline"
      size="xs"
      borderRadius="full"
      color="fg.neutral.muted"
      fontWeight="medium"
      truncate
      display="inline-flex"
      width="auto"
      maxW="full"
      minW={0}
      icon={icon}
    >
      {children}
    </Badge>
  );
}
